import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=177fadb1&"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('177fadb1')) {
      api.createRecord('177fadb1', component.options)
    } else {
      api.reload('177fadb1', component.options)
    }
    module.hot.accept("./FeedbackDialog.vue?vue&type=template&id=177fadb1&", function () {
      api.rerender('177fadb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/FeedbackDialog.vue"
export default component.exports